// extracted by mini-css-extract-plugin
module.exports = {"segmentedControls":"segmentedControls_segmentedControls__a8vZc"};